// extracted by mini-css-extract-plugin
export default {"menuLink":"styles_menuLink__m7p-k","menu":"styles_menu__3WwFj","img":"styles_img__uobBx","name":"styles_name__84hvm","logout":"styles_logout__Dz1I7"};